import React, { ReactElement } from 'react';
import { MESSAGES } from '../../data';

import './BrowserNotSupported.scss';
import { getIosVersion } from '../../utils/getIosVersion';

export function BrowserNotSupported(): ReactElement {
  const iosVersion = getIosVersion();
  return (
    <div className="browser-not-supported">
      <h1>{MESSAGES.BROWSER_ERROR_HEADING}</h1>
      <p>{MESSAGES.BROWSER_ERROR_DESCRIPTION}</p>
      {iosVersion === -1 && (
        <>
          <h2>{MESSAGES.BROWSER_ERROR_SUBHEADING}</h2>
          <h3>{MESSAGES.BROWSER_ERROR_NOTICE}</h3>
          <ul>
            <li>
              <a href="https://www.google.com/chrome/">
                <img
                  src="/images/browsers/chrome.png"
                  alt={MESSAGES.BROWSER_ERROR_DOWNLOAD.replace(
                    '%BROWSER%',
                    MESSAGES.BROWSER_ERROR_CHROME
                  )}
                />
                {MESSAGES.BROWSER_ERROR_CHROME}
              </a>
            </li>
            <li>
              <a href="https://www.mozilla.org/en-US/firefox/new/">
                <img
                  src="/images/browsers/firefox.png"
                  alt={MESSAGES.BROWSER_ERROR_DOWNLOAD.replace(
                    '%BROWSER%',
                    MESSAGES.BROWSER_ERROR_FIREFOX
                  )}
                />
                {MESSAGES.BROWSER_ERROR_FIREFOX}
              </a>
            </li>
            <li>
              <a href="https://www.microsoft.com/en-us/edge">
                <img
                  src="/images/browsers/edge.png"
                  alt={MESSAGES.BROWSER_ERROR_DOWNLOAD.replace(
                    '%BROWSER%',
                    MESSAGES.BROWSER_ERROR_EDGE
                  )}
                />
                {MESSAGES.BROWSER_ERROR_EDGE}
              </a>
            </li>
          </ul>
        </>
      )}
    </div>
  );
}
